
const state = {
  id: null,
  title: '',
  value: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'value' },
]

export default state
